import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { DataTransformService } from '@ridango/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ApplicationService {
    constructor(
        @Inject('ENV') private env: any,
        private http: HttpClient,
        private dataTransformer: DataTransformService,
    ) {}


}
